import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { UseFormReturn } from 'react-hook-form';
import { SwapDeviceFormSchemaType } from './swap-device-schema';

type FileUploadFormProps = {
	form: UseFormReturn<SwapDeviceFormSchemaType>;
	processObjectIds: string[];
};

const FileUploadStep = (props: FileUploadFormProps) => {
	const { form: poFileUploadForm, processObjectIds } = props;

	return (
		<div className="w-full flex flex-col gap-3 max-w-4xl">
			<FormField
				name="upload.title"
				control={poFileUploadForm.control}
				render={({ field }) => (
					<FormItem>
						<FormLabel>Title</FormLabel>
						<FormControl>
							<Input
								type="text"
								placeholder="File title here"
								onChange={field.onChange}
								onBlur={field.onBlur}
								name={field.name}
								value={field.value}
							/>
						</FormControl>
						<FormMessage />
					</FormItem>
				)}
			/>

			<FormField
				control={poFileUploadForm.control}
				name="upload.processObjectId"
				render={({ field }) => (
					<FormItem>
						<FormLabel>Process Object</FormLabel>

						<Select onValueChange={field.onChange} value={field.value ?? ''}>
							<FormControl>
								<SelectTrigger className="w-full">
									<SelectValue placeholder="Select a process object" />
								</SelectTrigger>
							</FormControl>
							<SelectContent>
								{processObjectIds.map(id => (
									<SelectItem key={id} value={id}>
										{id}
									</SelectItem>
								))}
							</SelectContent>
						</Select>
						<FormMessage />
					</FormItem>
				)}
			/>

			<FormField
				name="upload.description"
				control={poFileUploadForm.control}
				render={({ field }) => (
					<FormItem>
						<FormLabel>Description</FormLabel>
						<FormControl>
							<Input
								type="text"
								placeholder="File description here"
								onChange={field.onChange}
								onBlur={field.onBlur}
								name={field.name}
								value={field.value}
							/>
						</FormControl>
						<FormMessage />
					</FormItem>
				)}
			/>

			<FormField
				name="upload.file"
				control={poFileUploadForm.control}
				render={({ field }) => (
					<FormItem>
						<FormLabel>File</FormLabel>
						<FormControl>
							<Input
								type="file"
								className="cursor-pointer leading-7"
								onChange={e => field.onChange(e.target.files?.[0])}
								onBlur={field.onBlur}
								name={field.name}
							/>
						</FormControl>
						<FormMessage />
						{field.value && field.value.name && (
							<p className="mt-1 text-sm text-gray-600">
								Selected file: <strong>{field.value.name}</strong>
							</p>
						)}
					</FormItem>
				)}
			/>
		</div>
	);
};

export default FileUploadStep;
